export default __webpack_public_path__ + "static/media/ic-config.368304ee.svg";